import {
    AVIS_INICIALITZAR,
    AVIS_VISUALITZACIO_OBTENIR,
    AVIS_VISUALITZACIO_ELIMINAR
} from '../../../../actions/actionTypes';

const ESTAT_INICIAL_AVISOS = [];

const tots = (state = ESTAT_INICIAL_AVISOS, action) => {
    switch (action.type) {
        case AVIS_INICIALITZAR:
            return ESTAT_INICIAL_AVISOS;

        case AVIS_VISUALITZACIO_OBTENIR:
            return action.avisos;

        case AVIS_VISUALITZACIO_ELIMINAR:
            return state.filter(avis => avis.id !== action.id);

        default:
            return state;
    }
};

export default tots;



// WEBPACK FOOTER //
// ./src/reducers/avis/visualitzacio/avisos/tots.js